"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "JobsMetaController", {
    enumerable: true,
    get: function() {
        return JobsMetaController;
    }
});
const _common = require("@nestjs/common");
const _globalguard = require("~/guards/global/global.guard");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
const _jobsmetaservice = require("~/services/jobs-meta.service");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let JobsMetaController = class JobsMetaController {
    async jobList(context, req, conditions) {
        return await this.jobsMetaService.list(context, conditions, req);
    }
    constructor(jobsMetaService){
        this.jobsMetaService = jobsMetaService;
    }
};
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/jobs/:baseId'
    ]),
    (0, _extractidsmiddleware.Acl)('jobList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], JobsMetaController.prototype, "jobList", null);
JobsMetaController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _jobsmetaservice.JobsMetaService === "undefined" ? Object : _jobsmetaservice.JobsMetaService
    ])
], JobsMetaController);
